<template>
    <div>
        <loading-container v-if="loading"/>

        <div v-else>
            <headline-container :headline="page.attributes.title" :breadcrumbs="breadcrumbs"/>

            <div class="container">
                <div class="row">
                    <div class="col-xs-6">
                        <help-text>
                            <h3>
                                Edit Block
                            </h3>

                            <p>
                                You can use this form to edit a block
                            </p>
                        </help-text>
                    </div>

                    <div class="col-xs-18">
                        <form-panel
                                :value="block.attributes"
                                :portal="portal"
                                :block-types="blockTypes"
                                :errors="errors"
                                @submit="submit"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import http from '@/http'
    import notify from '@/notify'
    import Errors from '@/mixins/Errors'
    import FormPanel from '@/components/Panels/Administration/MarketingSites/Blocks/Form'
    import HeadlineContainer from '@/components/Layout/HeadlineContainer'
    import HelpText from '@/components/HelpText'
    import LoadingContainer from '@/components/Layout/LoadingContainer'

    export default {
        components: {FormPanel, HeadlineContainer, HelpText, LoadingContainer},

        mixins: [Errors],

        props: {
            portalId: {
                required: true
            },

            pageId: {
                required: true
            },

            blockId: {
                required: true
            }
        },

        data() {
            return {
                portal: null,
                page: null,
                block: null,
                blockTypes: null,

                loading: true
            }
        },

        mounted() {
            this.load()
        },

        computed: {
            breadcrumbs() {
                return [
                    {url: '/marketing-sites', text: 'Marketing Sites'},
                    {url: '/marketing-sites/' + this.portal.id, text: this.portal.attributes.name},
                    {
                        url: '/marketing-sites/' + this.portal.id + '/pages/' + this.page.id,
                        text: this.page.attributes.title
                    },
                    {text: this.block.attributes.block_type_name}
                ]
            }
        },

        methods: {
            load() {
                Promise.all([
                    http.get('/api/v2/portals/' + this.portalId),
                    http.get('/api/v2/marketing-site-pages/' + this.pageId),
                    http.get('/api/v2/marketing-site-blocks/' + this.blockId),
                    http.get('/api/v2/marketing-site-block-types')
                ])
                    .then(responses => {
                        this.portal = responses[0].data.data

                        this.page = responses[1].data.data

                        this.block = responses[2].data.data

                        this.blockTypes = responses[3].data.data

                        this.loading = false
                    })
            },

            submit(data) {
                http.put('/api/v2/marketing-site-blocks/' + this.block.id, data)
                    .then(() => {
                        notify.success('The block was saved')

                        this.$router.push('/marketing-sites/' + this.portal.id + '/pages/' + this.page.id)
                    }).catch(this.catchValidationErrors)
            }
        }
    }
</script>
